import {
  formatBuyerRef,
  formatNeedCount,
  formatNeedLocation,
  formatNeedPrice,
  formatNeedSqFt,
} from "./buyerNeedDisplay";

/**
 * One buyer's wants & needs, laid out the way the mobile Whiteboard row is so a
 * broker reads the same shape on either screen.
 */
const BuyerNeedCard = ({ criteria }) => {
  const ref = formatBuyerRef(criteria);

  return (
    <div className="border-b border-gray-100 px-4 py-3 last:border-b-0">
      <div className="mb-1 flex flex-wrap items-center justify-between gap-x-4 text-sm text-dark_gray">
        <span>
          <b className="font-extrabold">Buyer ID</b>{" "}
          <span className="font-bold text-blue">{ref ?? "—"}</span>
        </span>
        {criteria.agentName && (
          <span>
            <b className="font-extrabold">Agent:</b>{" "}
            <span className="font-bold text-blue">{criteria.agentName}</span>
          </span>
        )}
      </div>

      <div className="mb-0.5 flex flex-wrap items-center justify-between gap-x-4 text-sm text-secondary">
        <span>City: {formatNeedLocation(criteria)}</span>
        <span>Price: {formatNeedPrice(criteria)}</span>
      </div>

      <div className="flex flex-wrap gap-x-6 text-xs text-gray-400">
        <span>BDR: {formatNeedCount(criteria.minBeds, criteria.maxBeds)}</span>
        <span>BTH: {formatNeedCount(criteria.minBath, criteria.maxBath)}</span>
        <span>SQFT: {formatNeedSqFt(criteria)}</span>
      </div>

      {criteria.notes && (
        <div className="mt-1 text-xs italic text-gray-400">{criteria.notes}</div>
      )}
    </div>
  );
};

export default BuyerNeedCard;
